import * as R from 'ramda';
import { reducerWrapper } from '../support/utils';

import { SCHEDULE_GET, SCHEDULE_LIST, SCHEDULE_CREATE, SCHEDULE_UPDATE } from '../actions/ScheduleActions';

export const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
  scheduleList: null,
};

function Handler(state, action) {
  switch (action.type) {
    case SCHEDULE_UPDATE.response:
    case SCHEDULE_CREATE.response:
      return Object.assign({}, state, {
        loading: false,
        scheduleList: Object.assign({}, state.scheduleList, {
          [action.data.id]: action.data,
        }),
      });
    case SCHEDULE_GET.response:
      return R.merge(state, {
        loading: false,
        schedule: action.data,
      });
    case SCHEDULE_LIST.response:
      return R.merge(state, {
        loading: false,
        scheduleList: action.data,
      });
    default:
      return state;
  }
}

const Schedule = reducerWrapper(INIT_STATE, Handler, {
  request: [SCHEDULE_GET, SCHEDULE_LIST, SCHEDULE_CREATE, SCHEDULE_UPDATE],
  error: [SCHEDULE_GET, SCHEDULE_LIST, SCHEDULE_CREATE, SCHEDULE_UPDATE],
  resetOn: ['APP_CHANGE'],
});

export default Schedule;
